
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/shop/mirror",
      function () {
        return require("private-next-pages/shop/mirror.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/shop/mirror"])
      });
    }
  